import { match } from 'ts-pattern'

import { SentryConfig } from '@sequencehq/utils'

export const getNotificationSenderEmail = (
  environment: SentryConfig['environment']
): string =>
  match(environment)
    .with('production', () => 'notifications@mail.sequencehq.com')
    .otherwise(() => 'no-reply@mail.seqhq.io')
